import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './../Personnel/Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ShiftSchedule({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Shift Name",
        "Time From",
        "Time To",
        "",
    ]
    var accessor = [
        "id",
        "shiftName",
        "timeFrom",
        "timeTo",
        "manage"
    ]

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [shiftSchedule, setShiftSchedule] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholder, setSearchPlaceholder] = useState("shift name");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [shiftName, setShiftName] = useState("");
    const [timeFrom, setTimeFrom] = useState("");
    const [timeTo, setTimeTo] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editShiftName, setEditShiftName] = useState("");
    const [editTimeFrom, setEditTimeFrom] = useState("");
    const [editTimeTo, setEditTimeTo] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    //old
    const [oldShiftName, setOldShiftName] = useState("");
    const [oldTimeFrom, setOldTimeFrom] = useState("");
    const [oldTimeTo, setOldTimeTo] = useState("");

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const formatTime = (time) => {
        if(!time){
            return ""
        }
        let timeParts;
        const timeSplit = time.split('T');
        if (timeSplit?.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        const formattedTime = `${hours}:${minutes}`;

        return formattedTime;
    }

    const apiUrl =  domain + "/api/ShiftSchedule";

    const fetchData = useCallback(async (dataToFetch) => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + dataToFetch , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setShiftSchedule(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);
    
    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("shift name")
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholder("id")
                setDataToFetch("")
                break;
            default:
                setSearchPlaceholder("shift name")
                setDataToFetch("");
                break;
        }
        fetchData(dataToFetch);
        
    }, [filterDataIndex, dataToFetch, fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.shiftName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.shiftName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setShiftSchedule(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            shiftName: shiftName,
            timeFrom: timeFrom ? timeFrom : null,
            timeTo: timeTo  ? timeTo : null
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Shift Schedule", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.shiftName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setShiftName("");
            setTimeFrom("");
            setTimeTo("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            shiftName: editShiftName,
            timeFrom: editTimeFrom,
            timeTo: editTimeTo
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.shiftName !== oldShiftName){
                auditInfo.push({
                    setupArea: "Shift Schedule",
                    actionTaken: "update",
                    field: "Shift Name",
                    newValue: `${data.shiftName}`,
                    oldValue: `${oldShiftName}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.timeFrom !== oldTimeFrom){
                auditInfo.push({
                    setupArea: "Shift Schedule",
                    actionTaken: "update",
                    field: "Time From",
                    newValue: `${formatTime(data.timeFrom)}`,
                    oldValue: `${formatTime(oldTimeFrom)}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.timeTo !== oldTimeTo){
                auditInfo.push({
                    setupArea: "Shift Schedule",
                    actionTaken: "update",
                    field: "Time To",
                    newValue: `${formatTime(data.timeTo)}`,
                    oldValue: `${formatTime(oldTimeTo)}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditShiftName("");
            setEditTimeFrom("");
            setEditTimeTo("");
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditShiftName(data.shiftName);
        setEditTimeFrom(data.timeFrom);
        setEditTimeTo(data.timeTo);
        setOldShiftName(data.shiftName);
        setOldTimeFrom(data.timeFrom);
        setOldTimeTo(data.timeTo);
        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Time Keeping >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Shift Schedule"}</span>
                            </div>
                            <h3>Shift Schedule</h3>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        "Search by " + searchPlaceholder, 
                                                                        SearchIcon)}
                                </div>
                                <div className="body-top-btn row" style={{justifyContent: "end"}}>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={shiftSchedule}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    shiftName={shiftName}
                    timeFrom={timeFrom}
                    timeTo={timeTo}
                    setShiftName={setShiftName}
                    setTimeFrom={setTimeFrom}
                    setTimeTo={setTimeTo}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editShiftName={editShiftName}
                    editTimeFrom={editTimeFrom}
                    editTimeTo={editTimeTo}
                    setEditShiftName={setEditShiftName}
                    setEditTimeFrom={setEditTimeFrom}
                    setEditTimeTo={setEditTimeTo}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({isOpen, 
    onClose,
    shiftName,
    timeFrom,
    timeTo,
    setShiftName,
    setTimeFrom, 
    setTimeTo, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!shiftName) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };
    const handleClose = () => {
        onClose();
        setTimeFrom("");
        setTimeTo("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Shift Schedule</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Shift Name</div>
                            <div className="info-item-input">
                                <input
                                id="shiftName"
                                placeholder="Shift Name"
                                value={shiftName}
                                onChange={(e) => setShiftName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !shiftName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeFrom} setDate={setTimeFrom}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeTo} setDate={setTimeTo}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editShiftName, 
    editTimeFrom, 
    editTimeTo, 
    setEditShiftName, 
    setEditTimeFrom, 
    setEditTimeTo,   
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editShiftName || !editTimeFrom || !editTimeTo){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Shift Schedule</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Shift Name</div>
                            <div className="info-item-input">
                                <input
                                id="editShiftName"
                                placeholder="Shift Name"
                                value={editShiftName}
                                onChange={(e) => setEditShiftName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editShiftName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time From</div>
                            <div className="info-item-input"> 
                                <DateTimeInput date={editTimeFrom} setDate={setEditTimeFrom}/>
                            </div>
                            <span style={{
                                        visibility: !editTimeFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={editTimeTo} setDate={setEditTimeTo}/>
                            </div>
                            <span style={{
                                        visibility: !editTimeTo && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "ShiftId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="ShiftId">Shift Id</option>
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const getTimeString = (timeString) => {
        const [hours, minutes] = timeString.split(':');
        const now = new Date(); // Current date and time
        const year = now.getFullYear();
        const month = now.getMonth() + 1; // Month is zero-indexed, so add 1
        const day = now.getDate(); // Day of the month
        const formattedTime = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T${hours}:${minutes}`;
        return formattedTime;
    };

    const handleDateTimeChange = (event) => {
        setDate(getTimeString(event.target.value));
        console.log(getTimeString(event.target.value));
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let timePart = ""

    if(date){
        timePart = date.split('T')[1].substring(0, 5);
    }

    return (
        <div>
            <input
            type="time"
            id={"datetime-"}
            name="datetime"
            value={timePart}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
export default ShiftSchedule
